import { useDatabase } from '../rxdb/provider';
import { ProcessPropsForm } from './ProcessPropsForm';
import { UnstyledButton } from '@mantine/core';
import { modals } from '@mantine/modals';
import { Plus } from 'lucide-react';
import { ulid } from 'ulid';

type AddProcessButtonProps = {
  readonly workspaceId: string;
};

export const AddProcessButton = ({ workspaceId }: AddProcessButtonProps) => {
  const { db, userId } = useDatabase();

  const openDialogHandler = () => {
    const modalId = ulid();
    modals.open({
      children: (
        <ProcessPropsForm
          db={db}
          modalId={modalId}
          userId={userId}
          workspaceId={workspaceId}
        />
      ),
      modalId,
      title: 'New Process',
    });
  };

  return (
    <UnstyledButton
      className="w-full flex items-center gap-1.5 px-2 py-1.5 rounded-md text-sm text-black/40 dark:text-white/40 hover:text-black/70 dark:hover:text-white/70 hover:bg-black/5 dark:hover:bg-white/5 border border-dashed border-black/15 dark:border-white/15 hover:border-black/30 dark:hover:border-white/30 transition-colors"
      onClick={openDialogHandler}
    >
      <Plus size={16} />
      Add process
    </UnstyledButton>
  );
};
